/* ==========================================================================
   Emir ICE — fiche produit (refonte « 2 univers », 2026-10-12)
   Comportement des composants snippets/eix-p-* : variantes, prix (odomètre), quantité, urgence honnête,
   bouton, barre d'achat mobile, accordéons, guide des tailles, recommandations.

   Principes :
   - Aucune bibliothèque. Tout est ré-initialisable (InstantClick recharge le <body> sans recharger la page) :
     un seul jeu d'écouteurs globaux (garde window.__eixProduct), une initialisation par .eix-fiche.
   - Le thème reste la source de vérité des variantes : on écrit dans les <select class="single-option-selector">
     créés par Shopify.OptionSelectors, on déclenche leur « change » (selectCallback du thème : galerie,
     historique d'URL, <select name="id">), puis on vérifie name="id". emir-perso.js, Vanga, la pré-commande et
     l'alerte retour en stock lisent ce champ.
   - Les libellés propres et le sens de chaque option viennent du Liquid (data-eix-lib, data-eix-genre…) :
     une seule table de correspondance, côté serveur.
   - Aucune fausse urgence : compte à rebours vers une vraie heure limite (heure de Paris, jours ouvrés),
     stock lu sur la variante, offre masquée après sa date de fin.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__eixProduct && window.__eixProduct.demarrer) { window.__eixProduct.demarrer(); return; }

  var FICHES = [];
  var MOUV = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var NBSP = '\u00a0', FINE = '\u202f';

  /* ---------- petits outils ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function sur(el, type, fn, opts) { if (el) el.addEventListener(type, fn, opts || false); }
  function txt(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function deux(n) { return (n < 10 ? '0' : '') + n; }
  function lire(cle) { try { return JSON.parse(window.localStorage.getItem(cle)); } catch (e) { return null; } }
  function ecrire(cle, v) { try { window.localStorage.setItem(cle, JSON.stringify(v)); } catch (e) {} }
  function emettre(nom, detail) { try { document.dispatchEvent(new CustomEvent(nom, { detail: detail })); } catch (e) {} }

  /* ---------- montant français depuis les centimes (même règle que snippets/eix-p-montant) ---------- */
  function groupes(euros) { return String(euros).replace(/\B(?=(\d{3})+(?!\d))/g, '|'); }
  function eixMontant(centimes, symbole) {
    var c = Math.round(Number(centimes) || 0), signe = c < 0 ? '−' : '';
    c = Math.abs(c);
    var e = Math.floor(c / 100), ct = c % 100;
    return signe + groupes(e).replace(/\|/g, FINE) + (ct ? ',' + deux(ct) : '') + NBSP + (symbole || '€');
  }

  /* ---------- heure de Paris, jours ouvrés, jours fériés ---------- */
  var fmtParis = null;
  function parisMaintenant() {
    /* renvoie un horodatage « pseudo-UTC » dont les champs UTC sont l'heure murale de Paris */
    var d = new Date();
    try {
      if (!fmtParis) fmtParis = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
      var p = {};
      fmtParis.formatToParts(d).forEach(function (x) { p[x.type] = parseInt(x.value, 10); });
      if (p.hour === 24) p.hour = 0;
      return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
    } catch (e) {
      return d.getTime() - d.getTimezoneOffset() * 60000;
    }
  }
  var FERIES = {};
  function feries(an) {
    if (FERIES[an]) return FERIES[an];
    /* Pâques (algorithme de Meeus) */
    var a = an % 19, b = Math.floor(an / 100), c = an % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      mois = Math.floor((h + l - 7 * m + 114) / 31), jour = ((h + l - 7 * m + 114) % 31) + 1;
    var paques = Date.UTC(an, mois - 1, jour), J = 86400000, o = {};
    [[1, 1], [5, 1], [5, 8], [7, 14], [8, 15], [11, 1], [11, 11], [12, 25]].forEach(function (x) { o[Date.UTC(an, x[0] - 1, x[1])] = 1; });
    o[paques + J] = 1; o[paques + 39 * J] = 1; o[paques + 50 * J] = 1;
    FERIES[an] = o;
    return o;
  }
  function minuit(ts) { var d = new Date(ts); return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()); }
  function ouvre(ts) { var d = new Date(ts), j = d.getUTCDay(); if (j === 0 || j === 6) return false; return !feries(d.getUTCFullYear())[minuit(ts)]; }
  function ajouterOuvres(ts, n) { var t = minuit(ts); while (n > 0) { t += 86400000; if (ouvre(t)) n--; } return t; }
  function prochainOuvre(ts) { var t = minuit(ts); while (!ouvre(t)) t += 86400000; return t; }
  var JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  function jourLong(ts, avecMois) { var d = new Date(ts); return JOURS[d.getUTCDay()] + ' ' + (d.getUTCDate() === 1 ? '1er' : d.getUTCDate()) + (avecMois ? ' ' + MOIS[d.getUTCMonth()] : ''); }
  function duree(ms, secondes) {
    var s = Math.max(0, Math.floor(ms / 1000)), j = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), r = s % 60;
    if (j > 0) return j + NBSP + 'j ' + h + NBSP + 'h';
    if (h > 0) return h + NBSP + 'h ' + deux(m) + NBSP + 'min' + (secondes ? ' ' + deux(r) + NBSP + 's' : '');
    return m + NBSP + 'min ' + deux(r) + NBSP + 's';
  }
  function finDeJour(iso) { var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || '')); return m ? Date.UTC(+m[1], +m[2] - 1, +m[3], 23, 59, 59) : NaN; }

  /* ==========================================================================
     Une fiche
     ========================================================================== */
  function Fiche(racine) {
    var F = this;
    F.racine = racine;
    var brut = $('script[data-eix-data]', racine);
    try { F.D = JSON.parse(brut.textContent); } catch (e) { F.D = null; }
    if (!F.D) return;
    F.hote = $('[data-product-form]', racine);
    F.form = F.hote ? $('form[action*="/cart/add"]', F.hote) : null;
    if (!F.form) return;
    F.btn = $('[data-eix-btn]', F.form);
    F.groupes = $$('[data-eix-var]', racine).map(function (g) {
      return { el: g, i: parseInt(g.getAttribute('data-eix-var'), 10), genre: g.getAttribute('data-eix-genre'), nom: g.getAttribute('data-eix-nom'), jetons: $$('[data-eix-jeton]', g), val: $('[data-eix-var-val]', g), info: $('[data-eix-var-info]', g) };
    });
    F.parId = {};
    F.D.variantes.forEach(function (v) { F.parId[String(v.id)] = v; });
    F.prixVarie = F.D.variantes.some(function (v) { return v.p !== F.D.variantes[0].p; });
    F.variante = F.varianteNative() || F.D.variantes[0];
    F.pousse = false;
    F.panier = null;
    F.initVariantes();
    F.initQuantite();
    F.initBouton();
    F.initAccordeons();
    F.initGuide();
    F.initOffre();
    F.initCollante();
    F.initReco();
    F.initMemo();
    F.rendre(false);
    racine.classList.add('is-pret');
    /* Le thème construit ses sélecteurs après nous (jQuery ready) : on se recale une fois dessus. */
    setTimeout(function () { F.depuisNatif(); }, 400);
    setTimeout(function () { F.depuisNatif(); F.mesurerChat(); }, 1600);
    setTimeout(function () { if (F.vivante()) F.rendreBouton(); }, 3500);
    if (window.requestIdleCallback) window.requestIdleCallback(function () { F.lirePanier(); }, { timeout: 4000 }); else setTimeout(function () { F.lirePanier(); }, 2500);
  }

  Fiche.prototype.vivante = function () { return document.documentElement.contains(this.racine); };
  Fiche.prototype.champId = function () { return $('select[name="id"], input[name="id"]', this.form); };
  Fiche.prototype.varianteNative = function () { var c = this.champId(); return c ? this.parId[String(c.value)] || null : null; };

  /* ---------- variantes ---------- */
  Fiche.prototype.trouver = function (options) {
    var L = this.D.variantes;
    for (var k = 0; k < L.length; k++) { var ok = true; for (var j = 0; j < options.length; j++) if (L[k].o[j] !== options[j]) { ok = false; break; } if (ok) return L[k]; }
    return null;
  };
  Fiche.prototype.plusProche = function (i, valeur) {
    /* la combinaison exacte n'existe pas : variante qui a cette valeur et le plus d'options communes, disponible de préférence */
    var F = this, mieux = null, score = -1;
    F.D.variantes.forEach(function (v) {
      if (v.o[i] !== valeur) return;
      var s = 0;
      for (var j = 0; j < v.o.length; j++) if (j !== i && v.o[j] === F.variante.o[j]) s += 2;
      if (v.d) s += 1;
      if (s > score) { score = s; mieux = v; }
    });
    return mieux;
  };
  Fiche.prototype.initVariantes = function () {
    var F = this;
    F.groupes.forEach(function (g) {
      g.jetons.forEach(function (j) {
        sur(j, 'click', function () { F.choisir(g, j, true); });
        sur(j, 'keydown', function (ev) {
          var sens = (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') ? 1 : (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp') ? -1 : 0;
          if (!sens && ev.key !== 'Home' && ev.key !== 'End') return;
          ev.preventDefault();
          var visibles = g.jetons.filter(function (x) { return !x.hidden; });
          if (g.genre === 'longueur' || g.genre === 'epaisseur' || g.genre === 'dimension') visibles.sort(function (a, b) { return parseFloat(a.getAttribute('data-eix-n')) - parseFloat(b.getAttribute('data-eix-n')); });
          var k = visibles.indexOf(j);
          var cible = ev.key === 'Home' ? visibles[0] : ev.key === 'End' ? visibles[visibles.length - 1] : visibles[(k + sens + visibles.length) % visibles.length];
          if (cible) { cible.focus(); F.choisir(g, cible, true); }
        });
      });
    });
    /* le thème (ou un retour arrière du navigateur) change la variante : on suit */
    sur(F.form, 'change', function (ev) { if (!F.pousse && ev.target && ev.target.classList && ev.target.classList.contains('single-option-selector')) F.depuisNatif(); });
    if (window.jQuery) { try { window.jQuery(F.form).on('change.eix', '.single-option-selector', function () { if (!F.pousse) F.depuisNatif(); }); } catch (e) {} }
  };
  Fiche.prototype.choisir = function (g, jeton, parClient) {
    var F = this, valeur = jeton.getAttribute('data-eix-val');
    var options = F.variante.o.slice();
    options[g.i] = valeur;
    var v = F.trouver(options) || F.plusProche(g.i, valeur);
    if (!v) return;
    if (v === F.variante) return;
    if (parClient && (g.genre === 'bague' || g.genre === 'longueur')) ecrire('eix:taille:' + F.D.bijou + ':' + g.genre, { v: valeur, n: jeton.getAttribute('data-eix-n'), lib: jeton.getAttribute('data-eix-lib') });
    F.fixer(v, true);
    if (MOUV) { jeton.classList.remove('is-pulse'); void jeton.offsetWidth; jeton.classList.add('is-pulse'); }
  };
  Fiche.prototype.fixer = function (v, pousser) {
    var F = this;
    F.variante = v;
    if (pousser) F.versNatif(v);
    F.rendre(true);
    emettre('eix:variante', { variante: v, produit: F.D.id });
  };
  Fiche.prototype.versNatif = function (v) {
    var F = this, sels = $$('.single-option-selector', F.form), champ = F.champId();
    F.pousse = true;
    try {
      if (sels.length === v.o.length) {
        for (var j = 0; j < sels.length; j++) sels[j].value = v.o[j];
        if (window.jQuery) window.jQuery(sels[0]).trigger('change');
        else sels[0].dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (champ) {
        if (champ.disabled) champ.disabled = false;
        if (String(champ.value) !== String(v.id)) champ.value = String(v.id);
        /* événement natif : emir-perso.js et l'alerte retour en stock écoutent le formulaire */
        champ.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (!sels.length && window.history && window.history.replaceState && F.D.variantes.length > 1) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, document.title, u.pathname + u.search + u.hash);
      }
    } catch (e) {}
    F.pousse = false;
  };
  Fiche.prototype.depuisNatif = function () {
    var F = this; if (!F.vivante()) return;
    var v = F.varianteNative();
    if (v && v !== F.variante) { F.variante = v; F.rendre(true); }
    else F.rendreBouton();
  };

  /* ---------- cas logistique d'une variante (même règle que snippets/eix-p-contexte) ---------- */
  Fiche.prototype.cas = function (v) {
    var D = this.D;
    if (!v.d) return 'epuise';
    if (D.univers === 'surmesure') return 'surmesure';
    if (D.perso) return 'perso';
    if (v.g) return v.q > 0 ? 'stock' : 'commande';
    return D.univers === 'luxe' ? 'commande' : 'stock';
  };
  Fiche.prototype.stockSuivi = function (v) { return !!v.g && v.q > 0 && v.d; };

  /* ---------- rendu ---------- */
  Fiche.prototype.rendre = function (anime) {
    var F = this, v = F.variante;
    F.racine.setAttribute('data-eix-cas', F.cas(v));
    F.rendreJetons();
    F.rendrePrix(anime);
    F.rendreUrgence();
    F.rendreQuantite();
    F.rendreBouton();
    F.rendreCollante();
    if (F.guideOuvert) F.construireGuide();
    if (anime && MOUV) { var p = $('[data-eix-prix]', F.racine); if (p) { p.classList.remove('is-eclat'); void p.offsetWidth; p.classList.add('is-eclat'); } }
  };
  Fiche.prototype.rendreJetons = function () {
    var F = this, v = F.variante, D = F.D;
    F.groupes.forEach(function (g) {
      var actif = null;
      g.jetons.forEach(function (j) {
        var valeur = j.getAttribute('data-eix-val'), sel = v.o[g.i] === valeur;
        var options = v.o.slice(); options[g.i] = valeur;
        var cand = F.trouver(options), absent = !cand, epuise = cand ? !cand.d : !F.D.variantes.some(function (x) { return x.o[g.i] === valeur && x.d; });
        j.classList.toggle('is-actif', sel);
        j.classList.toggle('is-epuise', epuise);
        j.classList.toggle('is-absent', absent);
        j.setAttribute('aria-checked', sel ? 'true' : 'false');
        j.setAttribute('tabindex', sel ? '0' : '-1');
        txt($('[data-eix-jeton-etat]', j), epuise ? ' — épuisé' : '');
        var prix = $('[data-eix-jeton-prix]', j);
        if (prix && !F.prixVarie) txt(prix, '');
        else if (prix) {
          var p = cand ? cand.p : null;
          if (p === null) { F.D.variantes.forEach(function (x) { if (x.o[g.i] === valeur && (p === null || x.p < p)) p = x.p; }); txt(prix, p === null ? '' : 'dès ' + eixMontant(p, D.symbole)); }
          else txt(prix, eixMontant(p, D.symbole));
        }
        if (sel) actif = j;
      });
      if (!actif) return;
      txt(g.val, actif.getAttribute('data-eix-lib'));
      var info = actif.getAttribute('data-eix-info') || '';
      if (g.el.classList.contains('eix-var--fixe') && g.genre === 'pierre') { var s = $('.eix-jeton__s', actif); info = s ? s.textContent : info; }
      txt(g.info, info);
      /* résumé « Ce que comprend ce prix » */
      var ligne = $('[data-eix-inclus-opt="' + g.i + '"] [data-eix-inclus-val]', F.racine);
      if (ligne) { var lib = actif.getAttribute('data-eix-lib'), plus = (g.genre === 'titre' || g.genre === 'dimension') ? actif.getAttribute('data-eix-info') : ''; txt(ligne, lib + (plus ? ' · ' + plus : '')); }
    });
  };

  /* odomètre : chaque chiffre est une colonne 0-9 que l'on translate (transform uniquement) */
  function odometre(el, groupesTxt, anime) {
    var car = groupesTxt.split(''), cases = Array.prototype.slice.call(el.children);
    var meme = cases.length === car.length;
    if (meme) for (var i = 0; i < car.length; i++) { if ((car[i] === '|') !== cases[i].classList.contains('eix-odo__s')) { meme = false; break; } }
    var anciens = [];
    if (!meme) {
      /* on aligne les anciens chiffres par la droite pour que les unités restent les unités */
      cases.filter(function (c) { return c.classList.contains('eix-odo__c'); }).forEach(function (c) { anciens.push(c.getAttribute('data-d') || c.textContent.trim()); });
      el.textContent = '';
      var nChiffres = car.filter(function (c) { return c !== '|'; }).length, k = 0;
      car.forEach(function (c) {
        var n;
        if (c === '|') { n = document.createElement('i'); n.className = 'eix-odo__s'; }
        else { n = document.createElement('span'); n.className = 'eix-odo__c'; var depuis = anciens[anciens.length - (nChiffres - k)]; n.textContent = depuis !== undefined ? depuis : '0'; if (depuis === undefined) n.classList.add('is-neuf'); k++; }
        el.appendChild(n);
      });
      cases = Array.prototype.slice.call(el.children);
    }
    var rang = car.filter(function (c) { return c !== '|'; }).length;
    cases.forEach(function (c, idx) {
      if (c.classList.contains('eix-odo__s')) return;
      rang--;
      var cible = car[idx], bobine = c.firstElementChild && c.firstElementChild.classList.contains('eix-odo__r') ? c.firstElementChild : null;
      if (!bobine) {
        var depart = c.textContent.trim() || '0';
        if (!anime || !MOUV) { c.textContent = cible; c.setAttribute('data-d', cible); return; }
        if (depart === cible && !c.classList.contains('is-neuf')) { c.setAttribute('data-d', cible); return; }
        bobine = document.createElement('span'); bobine.className = 'eix-odo__r';
        for (var d = 0; d < 10; d++) { var b = document.createElement('b'); b.textContent = String(d); bobine.appendChild(b); }
        bobine.style.setProperty('--eix-d', depart);
        c.textContent = ''; c.appendChild(bobine);
        void bobine.offsetWidth;
      }
      bobine.style.setProperty('--eix-i', String(rang));
      if (!anime || !MOUV) bobine.style.transition = 'none'; else bobine.style.transition = '';
      bobine.style.setProperty('--eix-d', cible);
      c.setAttribute('data-d', cible);
      c.classList.remove('is-neuf');
    });
  }
  Fiche.prototype.rendrePrix = function (anime) {
    var F = this, v = F.variante, D = F.D, boite = $('[data-eix-prix]', F.racine);
    if (!boite) return;
    var odo = $('[data-eix-odo]', boite), cent = $('[data-eix-prix-cent]', boite), devise = $('[data-eix-prix-devise]', boite);
    if (v.p > 0) {
      odometre(odo, groupes(Math.floor(v.p / 100)), anime);
      txt(cent, v.p % 100 ? ',' + deux(v.p % 100) : '');
      if (devise) devise.hidden = false;
      txt($('[data-eix-prix-sr]', boite), eixMontant(v.p, D.symbole));
    } else {
      odo.textContent = D.gratuit || ''; txt(cent, ''); if (devise) devise.hidden = true;
      txt($('[data-eix-prix-sr]', boite), D.gratuit || '');
    }
    var solde = v.c > v.p, avant = $('[data-eix-prix-avant]', boite);
    boite.classList.toggle('is-solde', solde);
    if (avant) {
      avant.hidden = !solde;
      txt($('[data-eix-prix-barre]', avant), solde ? eixMontant(v.c, D.symbole) : '');
      txt($('[data-eix-prix-eco]', avant), solde ? eixMontant(v.c - v.p, D.symbole) : '');
    }
    var franco = $('[data-eix-franco-texte]', boite);
    if (franco) txt(franco, v.p >= D.franco ? 'Livraison suivie offerte en France' : 'Livraison offerte dès ' + eixMontant(D.franco, D.symbole) + ' d’achat en France');
    /* prix historiques du thème (masqués) : gardés à jour pour les applications qui les lisent */
    var net = $('[data-eix-offre-prix]', F.racine), offre = $('[data-eix-offre]', F.racine);
    if (net && offre) { var pct = parseFloat(offre.getAttribute('data-eix-offre-pourcent')) || 0; txt(net, eixMontant(Math.round(v.p * (100 - pct) / 100), D.symbole)); }
  };

  /* ---------- urgence honnête ---------- */
  Fiche.prototype.limite = function () {
    /* prochaine heure limite ouvrée, en pseudo-UTC de Paris */
    var D = this.D, m = parisMaintenant(), jour = minuit(m), h = (D.heure || 14) * 3600000;
    if (ouvre(m) && m < jour + h) return { quand: jour + h, jour: jour, aujourdhui: true, maintenant: m };
    var j2 = prochainOuvre(jour + 86400000);
    return { quand: j2 + h, jour: j2, aujourdhui: false, maintenant: m };
  };
  Fiche.prototype.rendreUrgence = function () {
    var F = this, v = F.variante, D = F.D, boite = $('[data-eix-urgence]', F.racine);
    if (!boite) return;
    var cas = F.cas(v), etat = $('[data-eix-etat]', boite), eStock = $('[data-eix-etat-stock]', boite);
    var bas = F.stockSuivi(v) && v.q <= (D.seuil || 5);
    if (etat) etat.classList.toggle('is-bas', cas === 'stock' && bas);
    if (eStock) txt(eStock, !v.g ? 'Disponible' : bas ? (v.q === 1 ? 'Dernière pièce en stock' : 'Plus que ' + v.q + ' en stock') : 'En stock');
    F.compte = (cas === 'stock' && F.stockSuivi(v));
    F.tic(true);
  };
  Fiche.prototype.tic = function (complet) {
    var F = this, D = F.D, boite = $('[data-eix-urgence]', F.racine);
    if (!boite) return;
    var expe = $('[data-eix-expe-texte]', boite), livr = $('[data-eix-livr-texte]', boite);
    if (F.compte) {
      var L = F.limite(), reste = L.quand - L.maintenant;
      if (expe) {
        if (complet || F._aujourdhui !== L.aujourdhui || !$('[data-eix-cr]', expe)) {
          F._aujourdhui = L.aujourdhui;
          expe.textContent = '';
          var demain = L.jour - minuit(L.maintenant) === 86400000, nomJour = demain ? 'demain' : JOURS[new Date(L.jour).getUTCDay()];
          var avant = L.aujourdhui ? 'Commandez dans ' : 'Commandez avant ' + nomJour + ' ' + (D.heure || 14) + NBSP + 'h, soit dans ';
          var apres = L.aujourdhui ? ' : préparation aujourd’hui, expédition sous 24 à 48' + NBSP + 'h ouvrées' : ' : préparation ' + nomJour + ', expédition sous 24 à 48' + NBSP + 'h ouvrées';
          expe.appendChild(document.createTextNode(avant));
          var b = document.createElement('b'); b.setAttribute('data-eix-cr', ''); b.className = 'eix-cr'; expe.appendChild(b);
          expe.appendChild(document.createTextNode(apres));
        }
        txt($('[data-eix-cr]', expe), duree(reste, L.aujourdhui));
      }
      if (livr && (complet || F._jourLivr !== L.jour)) {
        F._jourLivr = L.jour;
        var zone = D.pays === 'FR' ? [2, 3, 'Livraison estimée en France : '] : (/^(BE|CH|LU|MC|NL|IT|ES|PT|GB|US|CA)$/.test(D.pays) ? [3, 5, 'Livraison estimée (Chronopost) : '] : null);
        if (zone) {
          var tot = ajouterOuvres(L.jour, 1 + zone[0]), tard = ajouterOuvres(L.jour, 2 + zone[1]);
          var memeMois = new Date(tot).getUTCMonth() === new Date(tard).getUTCMonth();
          livr.textContent = '';
          livr.appendChild(document.createTextNode(zone[2] + 'entre le '));
          var b1 = document.createElement('b'); b1.textContent = jourLong(tot, !memeMois); livr.appendChild(b1);
          livr.appendChild(document.createTextNode(' et le '));
          var b2 = document.createElement('b'); b2.textContent = jourLong(tard, true); livr.appendChild(b2);
        }
      }
    } else if (complet) {
      if (expe) txt(expe, 'Expédition sous 24 à 48' + NBSP + 'h ouvrées');
      if (livr) txt(livr, D.pays === 'FR' ? 'Colissimo suivi : 2 à 3 jours ouvrés en France après expédition' : 'Livraison suivie : délai selon votre pays, indiqué avant le paiement');
      F._aujourdhui = null; F._jourLivr = null;
    }
    /* fête : date limite de commande réglée dans la section */
    var fete = $('[data-eix-fete]', boite);
    if (fete && complet) {
      var lim = finDeJour(fete.getAttribute('data-eix-fete-limite')), m = parisMaintenant();
      if (D.pays === 'FR' && !isNaN(lim) && lim >= m) { txt($('[data-eix-fete-texte]', fete), 'Pour une livraison avant ' + fete.getAttribute('data-eix-fete-libelle') + ' en France, commandez au plus tard le ' + jourLong(lim, true) + '.'); fete.hidden = false; }
      else fete.hidden = true;
    }
    /* offre : masquée dès que sa date de fin est passée, ou si la variante choisie dépasse le plafond réglé */
    var offre = $('[data-eix-offre]', F.racine);
    if (offre) {
      var fin = finDeJour(offre.getAttribute('data-eix-offre-fin')), now = parisMaintenant(), cr = $('[data-eix-offre-cr]', offre);
      var plafond = parseFloat(offre.getAttribute('data-eix-offre-plafond')) || 0;
      var cache = isNaN(fin) || fin < now || (plafond > 0 && F.variante.p >= plafond);
      if (offre.hidden !== cache) offre.hidden = cache;
      if (!cache && cr) txt(cr, ' · se termine dans ' + duree(fin - now, false));
    }
  };

  /* ---------- quantité ---------- */
  Fiche.prototype.initQuantite = function () {
    var F = this, boite = $('[data-eix-qte]', F.form);
    F.qte = $('input[name="quantity"]', F.form);
    if (!boite || !F.qte) return;
    function pas(d) {
      var n = parseInt(F.qte.value, 10) || 1, max = parseInt(F.qte.getAttribute('max'), 10) || 9999;
      n = Math.min(max, Math.max(1, n + d));
      F.qte.value = String(n);
      F.qte.dispatchEvent(new Event('change', { bubbles: true }));
      if (MOUV) { F.qte.classList.remove(d > 0 ? 'is-plus' : 'is-moins'); void F.qte.offsetWidth; F.qte.classList.add(d > 0 ? 'is-plus' : 'is-moins'); }
    }
    sur($('[data-eix-qte-moins]', boite), 'click', function () { pas(-1); });
    sur($('[data-eix-qte-plus]', boite), 'click', function () { pas(1); });
    sur(F.qte, 'change', function () { F.rendreQuantite(); F.rendreBouton(); F.rendreCollante(); });
    sur(F.qte, 'input', function () { F.rendreBouton(); });
    sur(F.qte, 'blur', function () { var n = parseInt(F.qte.value, 10); if (!n || n < 1) { F.qte.value = '1'; F.rendreQuantite(); F.rendreBouton(); } });
  };
  Fiche.prototype.quantite = function () { return Math.max(1, parseInt(this.qte && this.qte.value, 10) || 1); };
  Fiche.prototype.rendreQuantite = function () {
    var F = this, v = F.variante, boite = $('[data-eix-qte]', F.form);
    if (!boite || !F.qte) return;
    /* stock suivi et vente arrêtée à zéro : on ne propose pas plus que le stock réel */
    var max = (v.g && v.r === 'deny' && v.q > 0) ? v.q : 0;
    if (max) F.qte.setAttribute('max', String(max)); else F.qte.removeAttribute('max');
    var n = F.quantite();
    if (max && n > max) { n = max; F.qte.value = String(n); }
    var moins = $('[data-eix-qte-moins]', boite), plus = $('[data-eix-qte-plus]', boite);
    if (moins) moins.disabled = n <= 1;
    if (plus) plus.disabled = !!max && n >= max;
    var note = $('[data-eix-qte-note]', boite);
    if (note) { if (!note.hasAttribute('data-eix-base')) note.setAttribute('data-eix-base', note.textContent.trim()); var base = note.getAttribute('data-eix-base'); txt(note, (max && n >= max) ? 'Quantité maximale en stock : ' + max : base); }
  };

  /* ---------- bouton ---------- */
  Fiche.prototype.supplement = function () {
    /* chaîne au choix (emir-perso) : son prix s'ajoute à celui du pendentif */
    var c = $('.emir-chaine__lengths:not([hidden]) input[data-emir-chaine-variant]:checked', this.form);
    return c ? (parseInt(c.getAttribute('data-price'), 10) || 0) : 0;
  };
  Fiche.prototype.rendreBouton = function () {
    var F = this, v = F.variante, D = F.D, b = F.btn;
    if (!b) return;
    var texte = $('.text', b), prix = $('[data-eix-btn-prix]', b), zone = b.parentNode;
    if (!v.d) {
      F._coupe = true;
      if (!b.disabled) b.disabled = true;
      b.classList.add('disabled');
      if (texte && texte.textContent.trim() !== D.indisponible) texte.textContent = D.indisponible;
      if (prix) prix.hidden = true;
      if (zone) zone.classList.add('product-is-unavailable');
    } else {
      if (zone) zone.classList.remove('product-is-unavailable');
      if (texte && texte.textContent.trim() === D.indisponible) texte.textContent = b.getAttribute('data-label') || D.libelle;
      /* on ne réactive que ce que NOUS avons désactivé : Vanga, le thème et emir-perso.js gèrent leurs propres verrous */
      if (F._coupe) {
        F._coupe = false;
        b.classList.remove('disabled');
        if (b.disabled && !b.classList.contains('bv-perso-locked') && !b.classList.contains('is-charge') && !b.classList.contains('emir-busy')) b.disabled = false;
      }
      /* le prix vit dans un attribut (contenu généré en CSS) : le texte du bouton reste le libellé seul */
      if (prix) { var total = (v.p + F.supplement()) * F.quantite(), aff = eixMontant(total, D.symbole); prix.hidden = !(total > 0); if (prix.getAttribute('data-eix-v') !== aff) prix.setAttribute('data-eix-v', aff); }
    }
    var ex = $('[data-eix-express]', F.form);
    if (ex) ex.classList.toggle('is-vide', !$('shopify-accelerated-checkout, shop-pay-wallet-button, .shopify-payment-button__button, iframe', ex));
  };
  Fiche.prototype.lirePanier = function (suite) {
    var F = this;
    if (!window.fetch) { if (suite) suite(null); return; }
    window.fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var q = {}; (c.items || []).forEach(function (it) { q[it.variant_id] = (q[it.variant_id] || 0) + it.quantity; });
      var avant = F.panier; F.panier = q; if (suite) suite(avant, q);
    }).catch(function () { if (suite) suite(null); });
  };
  Fiche.prototype.etatBouton = function (etat, message) {
    var F = this, b = F.btn, msg = $('[data-eix-btn-msg]', F.form);
    if (!b) return;
    b.classList.remove('is-charge', 'is-ok', 'is-erreur');
    clearTimeout(F._tEtat);
    if (etat) b.classList.add('is-' + etat);
    if (msg) { txt(msg, message || (etat === 'ok' ? 'Ajouté au panier.' : '')); msg.classList.toggle('is-erreur', etat === 'erreur'); }
    if (etat === 'ok' || etat === 'erreur') F._tEtat = setTimeout(function () { b.classList.remove('is-ok', 'is-erreur'); if (etat === 'ok' && msg) txt(msg, ''); }, etat === 'ok' ? 2600 : 6000);
    var barre = $('[data-eix-collante-btn]', F.racine); if (barre) { barre.classList.remove('is-charge', 'is-ok'); if (etat === 'charge' || etat === 'ok') barre.classList.add('is-' + etat); }
  };
  Fiche.prototype.suivreAjout = function () {
    /* On ne fait qu'OBSERVER : c'est Vanga, le thème ou emir-perso.js qui ajoute au panier.
       Chargement = le bouton a été désactivé par l'un d'eux ; résultat = quantité réelle lue dans /cart.js. */
    var F = this, b = F.btn, id = F.variante.id, debut = Date.now(), vu = false;
    if (F._suivi) return;
    F._suivi = true;
    (function boucle() {
      if (!F.vivante()) { F._suivi = false; return; }
      var occupe = b.disabled || b.classList.contains('emir-busy');
      var ecoule = Date.now() - debut;
      if (!vu) {
        if (occupe && !b.classList.contains('bv-perso-locked')) { vu = true; F.etatBouton('charge'); }
        else if (ecoule > 6000) { F._suivi = false; return; } /* rien n'est parti (validation bloquée) */
        else if (ecoule > 2600 && !F._verif) {
          /* aucun verrou vu : on regarde quand même le panier une fois (autre gestionnaire d'ajout) */
          F._verif = true;
          F.lirePanier(function (avant, apres) { F._verif = false; if (avant && apres && (apres[id] || 0) > (avant[id] || 0)) { vu = true; debut = Date.now() - 16000; F.panier = avant; } });
        }
      } else if (!occupe || ecoule > 15000) {
        F.lirePanier(function (avant, apres) {
          F._suivi = false;
          if (!apres) { F.etatBouton(null); return; }
          var q0 = avant ? (avant[id] || 0) : 0, q1 = apres[id] || 0;
          if (q1 > q0 || (!avant && q1 > 0)) { F.etatBouton('ok'); emettre('eix:panier:ajoute', { variante: id }); }
          else F.etatBouton('erreur', 'L’ajout au panier n’a pas abouti. Vérifiez la quantité, puis réessayez.');
          F.rendreBouton();
        });
        return;
      }
      setTimeout(boucle, 90);
    })();
  };
  Fiche.prototype.initBouton = function () {
    var F = this;
    if (!F.btn) return;
    sur(F.form, 'change', function () { setTimeout(function () { F.rendreBouton(); F.rendreCollante(); }, 30); });
  };

  /* ---------- barre d'achat collante (mobile) ---------- */
  Fiche.prototype.initCollante = function () {
    var F = this, barre = $('[data-eix-collante]', F.racine);
    F.barre = barre;
    if (!barre || !F.btn || !('IntersectionObserver' in window)) return;
    var bouton = $('[data-eix-collante-btn]', barre);
    sur(bouton, 'click', function () {
      var v = F.variante;
      if (!v.d) { var bis = $('.emir-bis', F.racine); if (bis) { bis.scrollIntoView({ behavior: MOUV ? 'smooth' : 'auto', block: 'center' }); var em = $('input[type="email"]', bis); if (em) setTimeout(function () { try { em.focus({ preventScroll: true }); } catch (e) {} }, 500); } return; }
      if (F.btn.disabled || F.btn.classList.contains('bv-perso-locked')) {
        /* personnalisation obligatoire manquante : on amène au champ, le message d'emir-perso.js explique */
        var perso = $('.bv-perso, .emir-chaine', F.form) || F.btn;
        perso.scrollIntoView({ behavior: MOUV ? 'smooth' : 'auto', block: 'center' });
        var champ = $('[data-bv-perso-text], [data-bv-perso-choice]', F.form); if (champ) setTimeout(function () { try { champ.focus({ preventScroll: true }); } catch (e) {} }, 500);
        return;
      }
      F.btn.click();
    });
    var io = new IntersectionObserver(function (entrees) {
      var e = entrees[0];
      F._passe = !e.isIntersecting && e.boundingClientRect.top < 0; /* le bouton principal est sorti par le HAUT de l'écran */
      F.afficherCollante();
    }, { threshold: 0 });
    io.observe(F.btn);
    F._io = io;
    sur(F.form, 'focusin', function (ev) { if (ev.target && /^(INPUT|SELECT|TEXTAREA)$/.test(ev.target.tagName)) { F._saisie = true; F.afficherCollante(); } });
    sur(F.form, 'focusout', function () { F._saisie = false; setTimeout(function () { F.afficherCollante(); }, 200); });
  };
  Fiche.prototype.afficherCollante = function () {
    var F = this, barre = F.barre; if (!barre) return;
    var montrer = !!F._passe && !F._saisie && !F.guideOuvert && window.innerWidth < 799;
    if (montrer === F._collanteVue) return;
    F._collanteVue = montrer;
    if (montrer) { barre.hidden = false; void barre.offsetWidth; barre.classList.add('is-vue'); F.mesurerChat(); setTimeout(function () { F.mesurerChat(); }, 1200); }
    else { barre.classList.remove('is-vue'); setTimeout(function () { if (!F._collanteVue) barre.hidden = true; }, 320); }
  };
  Fiche.prototype.mesurerChat = function () {
    /* la bulle du chat Shopify (shadow DOM ouvert) : on laisse sa place à droite de la barre */
    var F = this, barre = F.barre; if (!barre) return;
    var droite = 0;
    try {
      var hote = document.querySelector('shopify-chat, inbox-online-store-chat');
      var racine = hote && hote.shadowRoot, boutons = [];
      if (racine) {
        boutons = $$('button, [role="button"]', racine);
        /* la bulle vit dans un second shadow DOM (shopify-agent-runtime) */
        $$('*', racine).forEach(function (n) { if (n.shadowRoot) boutons = boutons.concat($$('button, [role="button"]', n.shadowRoot)); });
      }
      boutons.forEach(function (b) {
        var r = b.getBoundingClientRect();
        if (r.width > 24 && r.width < 120 && r.left > window.innerWidth / 2 && r.bottom > window.innerHeight - 110) droite = Math.max(droite, Math.round(window.innerWidth - r.left + 8));
      });
    } catch (e) {}
    barre.style.setProperty('--eix-chat', droite + 'px');
  };
  Fiche.prototype.rendreCollante = function () {
    var F = this, barre = F.barre, v = F.variante, D = F.D; if (!barre) return;
    var total = (v.p + F.supplement()) * F.quantite();
    txt($('[data-eix-collante-prix]', barre), total > 0 ? eixMontant(total, D.symbole) : (D.gratuit || ''));
    var libs = F.groupes.map(function (g) { var a = g.jetons.filter(function (j) { return j.classList.contains('is-actif'); })[0]; return a ? a.getAttribute('data-eix-lib') : ''; }).filter(Boolean);
    txt($('[data-eix-collante-var]', barre), libs.length ? libs.join(' · ') : D.titre);
    var img = $('[data-eix-collante-img]', barre); if (img && v.i && img.getAttribute('src') !== v.i) img.setAttribute('src', v.i);
    var lib = $('[data-eix-collante-lib]', barre), verrou = F.btn && F.btn.classList.contains('bv-perso-locked');
    txt(lib, !v.d ? 'Me prévenir' : verrou ? 'Personnaliser' : 'Ajouter');
  };

  /* ---------- accordéons ---------- */
  Fiche.prototype.initAccordeons = function () {
    var F = this;
    $$('details.eix-acc', F.racine).forEach(function (d) {
      var tete = $('summary', d), corps = $('.eix-acc__corps', d);
      if (!tete || !corps || !corps.animate) return;
      sur(tete, 'click', function (ev) {
        if (!MOUV) return;
        ev.preventDefault();
        if (d._anim) d._anim.cancel();
        var ouvrir = !d.open || d.classList.contains('is-ferme');
        if (ouvrir) { d.open = true; d.classList.remove('is-ferme'); }
        var h = corps.scrollHeight;
        d.classList.toggle('is-ferme', !ouvrir);
        d._anim = corps.animate(ouvrir ? [{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }] : [{ height: corps.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: Math.min(520, 220 + h / 3), easing: 'cubic-bezier(.2,.7,.2,1)' });
        d._anim.onfinish = function () { if (!ouvrir) { d.open = false; d.classList.remove('is-ferme'); } d._anim = null; };
      });
    });
    /* description longue : repliée avec un bouton « Lire toute la description » */
    var desc = $('[data-eix-desc]', F.racine), plus = $('[data-eix-desc-plus]', F.racine);
    if (desc && plus) {
      var mesurer = function () { if (desc.classList.contains('is-ouvert')) return; var long = desc.scrollHeight > 460; desc.classList.toggle('is-coupe', long); plus.hidden = !long; };
      mesurer(); setTimeout(mesurer, 1200);
      sur(plus, 'click', function () {
        var ouvert = desc.classList.toggle('is-ouvert');
        desc.classList.toggle('is-coupe', !ouvert);
        plus.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
        txt($('span', plus), ouvert ? 'Replier la description' : 'Lire toute la description');
        if (!ouvert) desc.scrollIntoView({ block: 'nearest' });
      });
      /* listes dont chaque ligne commence déjà par une coche : pas de deuxième puce */
      var re = /^[\s\u00a0]*[☑✅✓✔]/;
      $$('ul', desc).forEach(function (ul) { var li = $$('li', ul); if (li.length && li.every(function (x) { return re.test(x.textContent || ''); })) ul.classList.add('eix-liste-coche'); });
    }
  };

  /* ---------- offre : copier le code ---------- */
  Fiche.prototype.initOffre = function () {
    var F = this, b = $('[data-eix-offre-copier]', F.racine);
    if (!b) return;
    sur(b, 'click', function () {
      var code = b.getAttribute('data-eix-code') || '', etiquette = $('[data-eix-offre-copier-texte]', b);
      function fait(ok) { txt(etiquette, ok ? 'Copié' : 'À saisir au paiement'); b.classList.add('is-copie'); setTimeout(function () { txt(etiquette, 'Copier'); b.classList.remove('is-copie'); }, 2400); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(function () { fait(true); }, function () { fait(false); });
      else fait(false);
    });
  };

  /* ---------- mémoire de la dernière taille choisie ---------- */
  Fiche.prototype.initMemo = function () {
    var F = this;
    F.groupes.forEach(function (g) {
      if (g.genre !== 'bague' && g.genre !== 'longueur') return;
      var m = lire('eix:taille:' + F.D.bijou + ':' + g.genre);
      if (!m) return;
      var j = g.jetons.filter(function (x) { return x.getAttribute('data-eix-val') === m.v || (m.n && x.getAttribute('data-eix-n') === m.n); })[0];
      if (!j || j.classList.contains('is-actif') || j.classList.contains('is-absent') || j.hidden) return;
      var puce = document.createElement('button');
      puce.type = 'button'; puce.className = 'eix-var__memo';
      puce.textContent = 'Votre dernière taille : ' + j.getAttribute('data-eix-lib') + (j.classList.contains('is-epuise') ? ' (épuisée ici)' : ' — la reprendre');
      sur(puce, 'click', function () { F.choisir(g, j, false); puce.remove(); });
      var tete = $('.eix-var__tete', g.el);
      if (tete && tete.parentNode) tete.parentNode.insertBefore(puce, tete.nextSibling);
      g.memo = j;
    });
  };

  /* ---------- guide des tailles ---------- */
  var SVGNS = 'http://www.w3.org/2000/svg';
  function svg(nom, attrs, texte) { var n = document.createElementNS(SVGNS, nom); for (var k in attrs) if (Object.prototype.hasOwnProperty.call(attrs, k)) n.setAttribute(k, attrs[k]); if (texte != null) n.textContent = texte; return n; }
  function el(nom, classe, texte) { var n = document.createElement(nom); if (classe) n.className = classe; if (texte != null) n.textContent = texte; return n; }
  var TOMBE = [[30, 82], [35, 88], [40, 98], [45, 113], [50, 129], [55, 148], [60, 166], [70, 204], [80, 236], [90, 262]]; /* longueur (cm) → ordonnée du point bas sur la silhouette */
  function ordonnee(cm) { for (var i = 1; i < TOMBE.length; i++) if (cm <= TOMBE[i][0]) { var a = TOMBE[i - 1], b = TOMBE[i]; return a[1] + (b[1] - a[1]) * (cm - a[0]) / (b[0] - a[0]); } return TOMBE[TOMBE.length - 1][1]; }
  function repere(cm) { return cm <= 42 ? 'base du cou' : cm <= 47 ? 'clavicules' : cm <= 52 ? 'sous les clavicules' : cm <= 62 ? 'haut du sternum' : 'sous la poitrine'; }

  Fiche.prototype.initGuide = function () {
    var F = this, tiroir = $('[data-eix-guide]', F.racine);
    F.tiroir = tiroir;
    $$('[data-eix-guide-ouvrir]', F.racine).forEach(function (b) { sur(b, 'click', function (ev) { ev.preventDefault(); if (tiroir) F.ouvrirGuide(b); }); });
    if (!tiroir) return;
    $$('[data-eix-guide-fermer]', tiroir).forEach(function (b) { sur(b, 'click', function () { F.fermerGuide(); }); });
    sur(tiroir, 'keydown', function (ev) {
      if (ev.key === 'Escape') { ev.preventDefault(); F.fermerGuide(); return; }
      if (ev.key !== 'Tab') return;
      var f = $$('a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]', tiroir).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (ev.shiftKey && document.activeElement === f[0]) { ev.preventDefault(); f[f.length - 1].focus(); }
      else if (!ev.shiftKey && document.activeElement === f[f.length - 1]) { ev.preventDefault(); f[0].focus(); }
    });
    F.initCalibrage(); F.initPoignet();
  };
  Fiche.prototype.ouvrirGuide = function (depuis) {
    var F = this, t = F.tiroir;
    F._retour = depuis || document.activeElement;
    F.guideOuvert = true;
    F.construireGuide();
    t.hidden = false; void t.offsetWidth; t.classList.add('is-ouvert');
    document.documentElement.classList.add('eix-fige');
    var p = $('.eix-tiroir__panneau', t); if (p) { try { p.focus({ preventScroll: true }); } catch (e) { p.focus(); } }
    F.afficherCollante();
  };
  Fiche.prototype.fermerGuide = function () {
    var F = this, t = F.tiroir; if (!t || !F.guideOuvert) return;
    F.guideOuvert = false;
    t.classList.remove('is-ouvert');
    document.documentElement.classList.remove('eix-fige');
    setTimeout(function () { if (!F.guideOuvert) t.hidden = true; }, MOUV ? 340 : 0);
    if (F._retour && F._retour.focus) { try { F._retour.focus({ preventScroll: true }); } catch (e) {} }
    F.afficherCollante();
  };
  Fiche.prototype.groupesTaille = function () { return this.groupes.filter(function (g) { return (g.genre === 'bague' || g.genre === 'longueur' || g.genre === 'dimension' || g.genre === 'epaisseur') && g.jetons.length; }); };
  Fiche.prototype.construireGuide = function () {
    var F = this, t = F.tiroir, D = F.D; if (!t) return;
    var G = F.groupesTaille();
    /* 1. tailles réellement proposées, avec « Choisir » */
    var bloc = $('[data-eix-guide-bloc="tailles"]', t), liste = $('[data-eix-guide-tailles]', t);
    if (bloc && liste) {
      liste.textContent = '';
      G.forEach(function (g) {
        if (G.length > 1) liste.appendChild(el('p', 'eix-guide__st', g.nom));
        var ul = el('ul', 'eix-tailles eix-tailles--' + g.genre);
        g.jetons.slice().sort(function (a, b) { return (parseFloat(a.getAttribute('data-eix-n')) || 0) - (parseFloat(b.getAttribute('data-eix-n')) || 0); }).forEach(function (j) {
          var li = el('li', 'eix-taille' + (j.classList.contains('is-actif') ? ' is-actif' : '') + (j.classList.contains('is-epuise') ? ' is-epuise' : ''));
          var sous = $('.eix-jeton__s', j);
          var nom = el('span', 'eix-taille__nom', j.getAttribute('data-eix-lib') + (g.genre === 'bague' && sous ? ' (' + sous.textContent + ')' : ''));
          var info = el('span', 'eix-taille__info', j.getAttribute('data-eix-info') || (sous && g.genre !== 'bague' ? sous.textContent : ''));
          li.appendChild(nom); li.appendChild(info);
          if (j.classList.contains('is-actif')) li.appendChild(el('span', 'eix-taille__etat', 'Votre sélection'));
          else {
            var b = el('button', 'eix-taille__choisir', j.classList.contains('is-epuise') ? 'Épuisée · voir' : 'Choisir'); b.type = 'button';
            sur(b, 'click', function () { F.choisir(g, j, true); });
            li.appendChild(b);
          }
          ul.appendChild(li);
        });
        liste.appendChild(ul);
      });
      bloc.hidden = !G.length;
    }
    /* 2. mémoire */
    var memo = $('[data-eix-guide-memo]', t);
    if (memo) { var gm = F.groupes.filter(function (g) { return g.memo && !g.memo.classList.contains('is-actif'); })[0]; memo.hidden = !gm; if (gm) txt(memo, 'La dernière fois, vous aviez choisi : ' + gm.memo.getAttribute('data-eix-lib') + '.'); }
    /* 3. silhouette : arcs des longueurs proposées */
    var buste = $('[data-eix-guide-bloc="buste"]', t), arcs = $('[data-eix-buste-arcs]', t);
    if (buste && arcs) {
      var gl = G.filter(function (g) { return g.genre === 'longueur'; })[0], longueurs = [], choisie = null;
      if (gl) gl.jetons.forEach(function (j) { var n = parseFloat(j.getAttribute('data-eix-n')); if (n >= 30 && n <= 95) { longueurs.push(n); if (j.classList.contains('is-actif')) choisie = n; } });
      if (!longueurs.length) $$('.emir-chaine__lengths:not([hidden]) .emir-chaine__len', F.form).forEach(function (l) { var n = parseFloat(l.textContent); if (n >= 30 && n <= 95 && longueurs.indexOf(n) < 0) { longueurs.push(n); if ($('input', l) && $('input', l).checked) choisie = n; } });
      longueurs.sort(function (a, b) { return a - b; });
      arcs.textContent = '';
      var yLibelle = -99;
      longueurs.forEach(function (cm) {
        var y = ordonnee(cm), actif = cm === choisie;
        arcs.appendChild(svg('path', { d: 'M73 82 Q100 ' + (2 * y - 82).toFixed(1) + ' 127 82', 'class': 'eix-buste__arc' + (actif ? ' is-actif' : '') }));
        var yl = Math.max(y, yLibelle + 15); yLibelle = yl;
        arcs.appendChild(svg('path', { d: 'M100 ' + y.toFixed(1) + ' L184 ' + yl.toFixed(1), 'class': 'eix-buste__fil' + (actif ? ' is-actif' : '') }));
        arcs.appendChild(svg('text', { x: 188, y: (yl + 3.5).toFixed(1), 'class': 'eix-buste__lib' + (actif ? ' is-actif' : '') }, String(cm).replace('.', ',') + ' cm · ' + repere(cm)));
      });
      /* pendentif : sa hauteur, à l'échelle de la silhouette (7 px par cm de tombé) */
      var gd = G.filter(function (g) { return g.genre === 'dimension'; })[0];
      if (gd && longueurs.length) {
        var jd = gd.jetons.filter(function (j) { return j.classList.contains('is-actif'); })[0], mm = jd ? parseFloat(jd.getAttribute('data-eix-n')) : 0, base = choisie || longueurs[Math.min(1, longueurs.length - 1)];
        if (mm > 0) { var y0 = ordonnee(base), h = mm / 10 * 7; arcs.appendChild(svg('rect', { x: 100 - Math.max(5, h * 0.36), y: y0.toFixed(1), width: (2 * Math.max(5, h * 0.36)).toFixed(1), height: h.toFixed(1), rx: 3, 'class': 'eix-buste__pend' })); }
      }
      buste.hidden = !longueurs.length;
    }
    /* 4. échelle : tailles comparées à une pièce de 1 € (23,25 mm) */
    var eb = $('[data-eix-guide-bloc="echelle"]', t), fig = $('[data-eix-echelle]', t);
    if (eb && fig) {
      var ge = G.filter(function (g) { return g.genre === 'dimension' || g.genre === 'epaisseur'; })[0], tailles = [];
      if (ge) ge.jetons.forEach(function (j) { var n = parseFloat(j.getAttribute('data-eix-n')); if (n > 0) tailles.push({ mm: n, lib: j.getAttribute('data-eix-lib'), actif: j.classList.contains('is-actif') }); });
      tailles.sort(function (a, b) { return a.mm - b.mm; });
      fig.textContent = '';
      if (tailles.length) {
        var max = Math.max(23.25, tailles[tailles.length - 1].mm), ech = Math.min(6, 150 / max), sol = 176, x = 14, rayon = 23.25 * ech / 2;
        var pas = Math.max(26, (320 - 28 - 2 * rayon - 12) / tailles.length);
        fig.appendChild(svg('circle', { cx: (x + rayon).toFixed(1), cy: (sol - rayon).toFixed(1), r: rayon.toFixed(1), 'class': 'eix-ech__piece' }));
        fig.appendChild(svg('circle', { cx: (x + rayon).toFixed(1), cy: (sol - rayon).toFixed(1), r: (rayon * 0.72).toFixed(1), 'class': 'eix-ech__piece2' }));
        fig.appendChild(svg('text', { x: (x + rayon).toFixed(1), y: (sol - rayon + 4).toFixed(1), 'text-anchor': 'middle', 'class': 'eix-ech__txt' }, '1 €'));
        fig.appendChild(svg('text', { x: (x + rayon).toFixed(1), y: sol + 16, 'text-anchor': 'middle', 'class': 'eix-ech__lib' }, '23,25 mm'));
        x += 2 * rayon + 12;
        tailles.forEach(function (s, k) {
          var h = s.mm * ech, w = Math.min(pas - 8, Math.max(8, h * 0.62)), cx = x + pas * k + pas / 2;
          fig.appendChild(svg('rect', { x: (cx - w / 2).toFixed(1), y: (sol - h).toFixed(1), width: w.toFixed(1), height: h.toFixed(1), rx: Math.min(6, w / 3).toFixed(1), 'class': 'eix-ech__forme' + (s.actif ? ' is-actif' : '') }));
          fig.appendChild(svg('text', { x: cx.toFixed(1), y: sol + 16, 'text-anchor': 'middle', 'class': 'eix-ech__lib' + (s.actif ? ' is-actif' : '') }, s.lib.replace(' mm', '')));
        });
        fig.appendChild(svg('path', { d: 'M8 ' + sol + 'H312', 'class': 'eix-ech__sol' }));
        fig.appendChild(svg('text', { x: 312, y: sol + 30, 'text-anchor': 'end', 'class': 'eix-ech__unite' }, 'hauteur en mm'));
      }
      eb.hidden = !tailles.length;
    }
    /* 5. poignet */
    var pb = $('[data-eix-guide-bloc="poignet"]', t);
    if (pb) { pb.hidden = !G.some(function (g) { return g.genre === 'longueur' && g.jetons.some(function (j) { return parseFloat(j.getAttribute('data-eix-n')) < 30; }); }); F.conseilPoignet(); }
    F.rendreCalibrage();
  };

  /* bracelet : longueur conseillée = tour de poignet + 1 à 2 cm (règle du guide de la boutique) */
  Fiche.prototype.initPoignet = function () {
    var F = this, champ = $('[data-eix-poignet]', F.tiroir); if (!champ) return;
    var m = lire('eix:poignet'); if (m && m > 9 && m < 27) champ.value = String(m);
    sur(champ, 'input', function () { F.conseilPoignet(); });
  };
  Fiche.prototype.conseilPoignet = function () {
    var F = this, champ = $('[data-eix-poignet]', F.tiroir), res = $('[data-eix-poignet-res]', F.tiroir); if (!champ || !res) return;
    var p = parseFloat(String(champ.value).replace(',', '.'));
    res.textContent = '';
    if (!(p >= 10 && p <= 26)) { res.textContent = 'Ajoutez 1 à 2 cm à votre tour de poignet pour un port confortable.'; return; }
    ecrire('eix:poignet', p);
    var g = F.groupesTaille().filter(function (x) { return x.genre === 'longueur'; })[0]; if (!g) return;
    var tri = g.jetons.slice().sort(function (a, b) { return parseFloat(a.getAttribute('data-eix-n')) - parseFloat(b.getAttribute('data-eix-n')); });
    var bon = tri.filter(function (j) { return parseFloat(j.getAttribute('data-eix-n')) >= p + 1; })[0];
    if (!bon) { res.textContent = 'Aucune des longueurs proposées ne laisse 1 cm d’aisance pour un poignet de ' + String(p).replace('.', ',') + ' cm. Écrivez-nous : nous cherchons une solution avec vous.'; return; }
    var n = parseFloat(bon.getAttribute('data-eix-n')), ecart = n - p;
    var port = ecart <= 1.5 ? 'port ajusté' : ecart <= 2.5 ? 'port confortable' : 'port souple, le bracelet glisse sur la main';
    res.appendChild(document.createTextNode('Longueur conseillée : '));
    res.appendChild(el('b', '', bon.getAttribute('data-eix-lib')));
    res.appendChild(document.createTextNode(' (' + String(Math.round(ecart * 10) / 10).replace('.', ',') + ' cm d’aisance, ' + port + ').' + (bon.classList.contains('is-epuise') ? ' Elle est épuisée pour le moment.' : ' ')));
    if (!bon.classList.contains('is-actif')) { var b = el('button', 'eix-taille__choisir', 'Choisir ' + bon.getAttribute('data-eix-lib')); b.type = 'button'; sur(b, 'click', function () { F.choisir(g, bon, true); }); res.appendChild(b); }
  };

  /* bague : mesure à l'écran, uniquement après calibrage avec une carte bancaire (côté court : 53,98 mm) */
  Fiche.prototype.initCalibrage = function () {
    var F = this, boite = $('[data-eix-cal]', F.tiroir); if (!boite) return;
    var curseur = $('[data-eix-cal-curseur]', boite), carte = $('[data-eix-cal-carte]', boite);
    F.cal = { boite: boite, pxmm: lire('eix:pxmm'), k: 0 };
    function regler() { carte.style.width = curseur.value + 'px'; }
    sur(curseur, 'input', regler);
    sur($('[data-eix-cal-valider]', boite), 'click', function () { F.cal.pxmm = parseFloat(curseur.value) / 53.98; ecrire('eix:pxmm', F.cal.pxmm); F.rendreCalibrage(); });
    sur($('[data-eix-cal-refaire]', boite), 'click', function () { F.cal.pxmm = null; ecrire('eix:pxmm', null); F.rendreCalibrage(); });
    sur($('[data-eix-cal-moins]', boite), 'click', function () { F.cal.k--; F.rendreCalibrage(true); });
    sur($('[data-eix-cal-plus]', boite), 'click', function () { F.cal.k++; F.rendreCalibrage(true); });
    sur($('[data-eix-cal-choisir]', boite), 'click', function () { var c = F.cal.courant; if (c) F.choisir(c.g, c.j, true); });
    regler();
  };
  Fiche.prototype.rendreCalibrage = function (garder) {
    var F = this, C = F.cal; if (!C) return;
    var g = F.groupesTaille().filter(function (x) { return x.genre === 'bague'; })[0];
    C.boite.hidden = !g;
    if (!g) return;
    var e1 = $('[data-eix-cal-etape="1"]', C.boite), e2 = $('[data-eix-cal-etape="2"]', C.boite), curseur = $('[data-eix-cal-curseur]', C.boite);
    var largeur = $('.eix-cal__zone', C.boite) ? $('.eix-cal__zone', C.boite).clientWidth : 0;
    if (largeur > 100) curseur.max = String(Math.max(200, largeur - 4));
    var ok = C.pxmm && C.pxmm > 2 && C.pxmm < 12;
    e1.hidden = !!ok; e2.hidden = !ok;
    if (!ok) { if (C.pxmm) curseur.value = String(C.pxmm * 53.98); return; }
    var tri = g.jetons.filter(function (j) { return parseFloat(j.getAttribute('data-eix-diam')) > 0; }).sort(function (a, b) { return parseFloat(a.getAttribute('data-eix-diam')) - parseFloat(b.getAttribute('data-eix-diam')); });
    if (!tri.length) { C.boite.hidden = true; return; }
    if (!garder) { var k0 = tri.indexOf(tri.filter(function (j) { return j.classList.contains('is-actif'); })[0]); C.k = k0 < 0 ? 0 : k0; }
    C.k = Math.max(0, Math.min(tri.length - 1, C.k));
    var j = tri[C.k], diam = parseFloat(j.getAttribute('data-eix-diam')), cercle = $('[data-eix-cal-cercle]', C.boite);
    cercle.style.width = cercle.style.height = (diam * C.pxmm).toFixed(1) + 'px';
    C.courant = { g: g, j: j };
    txt($('[data-eix-cal-lib]', C.boite), 'Taille ' + j.getAttribute('data-eix-lib') + ' · Ø ' + String(diam).replace('.', ',') + ' mm' + (j.classList.contains('is-epuise') ? ' (épuisée)' : ''));
    $('[data-eix-cal-moins]', C.boite).disabled = C.k === 0;
    $('[data-eix-cal-plus]', C.boite).disabled = C.k === tri.length - 1;
    var choisir = $('[data-eix-cal-choisir]', C.boite); choisir.disabled = j.classList.contains('is-actif'); txt($('span', choisir), j.classList.contains('is-actif') ? 'C’est votre sélection' : 'Choisir cette taille');
  };

  /* ---------- recommandations : titre de l'univers, pas de mélange si possible ---------- */
  function universDuTitre(t) {
    t = String(t || '').toLowerCase();
    if (/sur[ -]mesure|faire un|faire des|acompte/.test(t)) return 'surmesure';
    if (/moissanite|laboratoire|naturel|vvs|emir luxe/.test(t)) return 'luxe';
    return 'gp';
  }
  Fiche.prototype.initReco = function () {
    var F = this, D = F.D, section = F.racine.parentNode;
    var boite = section ? $('[data-product-recommendations-container]', section) : null;
    if (!boite || !D.reco || !('MutationObserver' in window)) return;
    function traiter() {
      var titre = $('.recommended-products__title .title', boite);
      if (!titre) return false;
      if (D.reco.titre) txt(titre, D.reco.titre);
      if (D.reco.filtrer && D.univers !== 'surmesure') {
        var cartes = $$('.products-slider .gallery-cell, .product-list .thumbnail', boite), dehors = [];
        cartes.forEach(function (c) { var t = $('.title', c); if (t && universDuTitre(t.textContent) !== D.univers) dehors.push(c); });
        if (dehors.length && cartes.length - dehors.length >= 4) {
          var glissiere = $('.products-slider', boite), fl = null;
          try { fl = glissiere && window.Flickity ? window.Flickity.data(glissiere) : null; } catch (e) {}
          if (fl && fl.remove) { try { fl.remove(dehors); fl.select(0, false, true); } catch (e) { dehors.forEach(function (c) { c.remove(); }); } }
          else dehors.forEach(function (c) { c.remove(); });
        }
      }
      return true;
    }
    if (traiter()) return;
    var obs = new MutationObserver(function () { if (!F.vivante()) { obs.disconnect(); return; } if (traiter()) obs.disconnect(); });
    obs.observe(boite, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 20000);
  };

  /* ==========================================================================
     Démarrage, écouteurs globaux (une seule fois)
     ========================================================================== */
  function ficheDe(noeud) { for (var i = 0; i < FICHES.length; i++) if (FICHES[i].racine.contains(noeud)) return FICHES[i]; return null; }
  function demarrer() {
    FICHES = FICHES.filter(function (f) { return f.vivante(); });
    $$('[data-eix-fiche]').forEach(function (r) {
      if (r.getAttribute('data-eix-pret') === '1') return;
      r.setAttribute('data-eix-pret', '1');
      try { var f = new Fiche(r); if (f.D && f.form) FICHES.push(f); } catch (e) { if (window.console) console.warn('[eix-product]', e); }
    });
  }
  /* clic sur le bouton d'ajout : on observe depuis window en capture (Vanga et emir-perso.js interceptent tôt) */
  window.addEventListener('click', function (ev) {
    var t = ev.target, b = t && t.closest ? t.closest('[data-eix-btn]') : null;
    if (!b || b.disabled) return;
    var f = ficheDe(b); if (!f) return;
    if (MOUV) { b.classList.add('is-appui'); setTimeout(function () { b.classList.remove('is-appui'); }, 240); }
    setTimeout(function () { f.suivreAjout(); }, 0);
  }, true);
  setInterval(function () { if (document.hidden) return; for (var i = 0; i < FICHES.length; i++) if (FICHES[i].vivante()) FICHES[i].tic(false); }, 1000);
  window.addEventListener('resize', function () { for (var i = 0; i < FICHES.length; i++) if (FICHES[i].vivante()) { FICHES[i].afficherCollante(); FICHES[i].mesurerChat(); } });
  document.addEventListener('emir:cart:added', function () { for (var i = 0; i < FICHES.length; i++) if (FICHES[i].vivante()) FICHES[i].lirePanier(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) for (var i = 0; i < FICHES.length; i++) if (FICHES[i].vivante()) { FICHES[i].tic(true); FICHES[i].lirePanier(); } });

  window.__eixProduct = {
    demarrer: demarrer,
    montant: eixMontant,
    /* utilisé par assets/emir-perso.js pour l'ajout « pendentif + chaîne » */
    etat: function (bouton, etat, message) { var f = ficheDe(bouton); if (!f) return false; f.etatBouton(etat, message); if (etat === 'ok') f.lirePanier(); return true; },
    fiches: function () { return FICHES; }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
  document.addEventListener('page:load', demarrer);
  document.addEventListener('shopify:section:load', demarrer);
  document.addEventListener('instantclick:newpage', demarrer);
  if (window.InstantClick && typeof window.InstantClick.on === 'function') { try { window.InstantClick.on('change', demarrer); } catch (e) {} }
})();
